import React from 'react'
import { useValue, WhenModelValue } from '@morningtrain/react-resources'
import { Translation } from '@morningtrain/react-translations'
import * as Displays from 'support/displays'

export function RequestFromTo () {

  const requestedStartAt = useValue('requested_start_at')
  const requestedEndAt = useValue('requested_end_at')

  return (
    <>
      <div className="flex justify-between">
        <span>
          <Translation name="approved_start_at"/>
          <WhenModelValue name="start_at" condition={startAt => startAt !== requestedStartAt}>
            <span className="text-red-500">(<Translation name="changed"/>)</span>
          </WhenModelValue>
        </span>
        <Displays.Date name="start_at"/>
      </div>
      <div className="flex justify-between">
        <span>
          <Translation name="approved_end_at"/>
          <WhenModelValue name="end_at" condition={endAt => endAt !== requestedEndAt}>
            <span className="text-red-500"> (<Translation name="changed"/>)</span>
          </WhenModelValue>
        </span>
        <Displays.Date name="end_at"/>
      </div>
    </>
  )
}
